<template>
    <CodiceFeanorView tool-module="passwordCracker" />
</template>

<script setup>
import CodiceFeanorView from "../CodiceFeanorView.vue";
</script>
